<template>
  <!-- Reports Modal -->
  <b-modal
    id="reportsIntersectionModal"
    size="xl"
    content-class="menu-bg-blue-transparent-modal"
    body-class="scroll-Container"
    title="Intersection Summary and Reports"
    hide-footer
   
    scrollable
    @show="getANSIReport()"
    @shown="createMap()"
  >
    <!-- Selset selector -->
    <b-row class="mx-5">
      <b-col class="col-sm-5 py-2">
        <b-form-select
          v-model="selected"
          class="scroll-Container"
          @change="refreshModal($event)"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>
              Select Selset
            </b-form-select-option>
          </template>
          <b-form-select-option
            v-for="(set, index) in selset"
            :key="index"
            :value="set.selset"
          >
            {{ set.selset }}
          </b-form-select-option>
        </b-form-select>
      </b-col>
      <b-col class="col-sm-7 py-2">
        <b-row class="py-1 ml-5">
          <b-col>
            <h5>Total Segments: {{ total }}</h5>
          </b-col>
          <b-col>
            <h5>Part Number: {{ partNumber }}</h5>
          </b-col>
        </b-row>
        <b-row class="py-1 ml-5">
          <b-col>
            <h5>Created Date: {{ createdDate }}</h5>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <div>
      <b-tabs align="center" pills card>
        <b-tab title="Summary" active>
          <b-row class="col-md-12 pb-5">
            <b-col>
              <apexchart
                type="donut"
                width="700"
                :options="chartOptions"
                :series="series"
              ></apexchart>
              <b-row> </b-row>
            </b-col>
            <b-col>
              <div>
                <div id="mapANSI" class="ol-map mapANSI"></div>
              </div>
            </b-col>
          </b-row>
          <div class="text-center">
            <b-button
              type="button"
              variant="success"
              class="mx-2"
              @click="createReport"
            >
              CSV Download
            </b-button>
            <b-button
              type="button"
              variant="success"
              class="mx-2"
              @click="createShapefileLink"
            >
              Shapefile Download
            </b-button>
          </div>
        </b-tab>
        <b-tab title="Issues">
          <vue-bootstrap4-table
            :rows="issuesRows"
            :columns="issuesColumns"
            :config="config"
            :classes="classes"
          >
          </vue-bootstrap4-table>
        </b-tab>
        <b-tab title="Subcountries">
          <vue-bootstrap4-table
            :rows="subcountryRows"
            :columns="subcountryColumns"
            :config="config"
            :classes="classes"
          >
          </vue-bootstrap4-table>
        </b-tab>
      </b-tabs>
    </div>
  </b-modal>
</template>
<style scoped>
.mapANSI {
  height: clamp(300px, 55vh, 600px) !important;
  width: min(43.75rem, 100%);
}
</style>
<script>
import axios from 'axios'
import GeoJSON from 'ol/format/GeoJSON'
import VectorSource from 'ol/source/Vector'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import {get as projGet, transformExtent} from 'ol/proj'
import Map from 'ol/Map'
import OSM from 'ol/source/OSM'
import TileLayer from 'ol/layer/Tile'
import {createLayers} from '../../../utils/utils.js'
import View from 'ol/View'
import * as XLSX from 'xlsx'
export default {
  name: 'MMP_Intersection_Reports',
  props: [
    'ansiLayerName',
    'ansiSelectedSelset',
    'apiUrl',
    'currentANSIPartNumber',
    'layerDefinition',
    'mmp_layersObj'
  ],
  components: {
    VueBootstrap4Table
  },
  data() {
    return {
      mapANSI: null,
      chart: null,
      total: null,
      layerType: null,
      url: null,
      series: [],
      chartOptions: {
        chart: {
          id: 'IntersectionReport',
          width: 360,
          type: 'donut'
        },
        labels: [],
        legend: {
          labels: {
            useSeriesColors: true
          }
        },
        plotOptions: {},
        dataLabels: {
          enabled: true
        }
      },
      selset: null,
      selected: null,
      partNumber: null,
      reportRows: [],
      classes: {
        table: {
          'menu-bg-blue-transparent-modal': true
        }
      },
      config: {
        checkbox_rows: false,
        rows_selectable: true,
        card_mode: false,
        global_search: {
          placeholder: 'Search...',
          visibility: true,
          showClearButton: true,
          searchOnPressEnter: true
        },
        highlight_row_hover_color: '#4a4a4a',
        per_page: 15,
        show_refresh_button: false,
        show_reset_button: false
      },
      issuesRows: [],
      issuesColumns: [
        {
          label: 'Intersection Id',
          name: 'id',
          sort: true
        },
        {
          label: 'Subcountry',
          name: 'state_name',
          sort: true
        },
        {
          label: 'Technician',
          name: 'technician',
          sort: true
        },
        {
          label: 'Notes',
          name: 'notes',
          sort: true
        },
        {
          label: 'Review Date',
          name: 'last_updated',
          sort: true
        }
      ],
      subcountryRows: [],
      subcountryColumns: [
        {
          label: 'Subcountry',
          name: 'subcountry',
          sort: true
        },
        {
          label: 'Count',
          name: 'count',
          sort: true
        }
      ],
      totalReviewTime: null,
      createdDate: null,
      ansiData: [],
      dropdownSelsetValue: null,
      originalLayerSource: null,
      geoserverDetails: [
        {workspace: 'gm', layer: 'gm:ansi_reports_gm', name: 'ansi_gm'},
        {
          workspace: 'nissan_ansi_workspace',
          layer: 'nissan_ansi_workspace:ansi_reports_nissan',
          name: 'ansi_nissan'
        },
        {
          workspace: 'subaru',
          layer: 'subaru:ansi_reports_subaru',
          name: 'ansi_subaru'
        },
        {
          workspace: 'toyota',
          layer: 'toyota:ansi_reports_toyota',
          name: 'ansi_toyota'
        },
        {
          workspace: 'rivian_alpha_workspace',
          layer: 'rivian_alpha_workspace:ansi_reports_rivian',
          name: 'ansi'
        }
      ],
      layerExtent: []
    }
  },
  methods: {
    getReport(params) {
      this.getSelset()
      this.selected = String(params)
      this.dropdownSelsetValue = this.selected
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION +
              `/api/${this.apiUrl}/intersectionReport/${params}`,
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              }
            }
          )
          .then(response => {
            const content = response.data
            this.renderChart(content)
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    createReport() {
      /* This method is required because you can't pass
      the 'this' variable in the Vue @click event */
      this.createCSV(this)
    },
    createCSV: async self => {
      await Promise.all([
        self.getAnsiIssues(self),
        self.getAnsiSubcountries(self),
        self.getAnsiData(self)
      ]).then(values => {
        // The values array holds data in the same order as the above Promises
        let ansiData = XLSX.utils.json_to_sheet(values[0])
        let subcountryRows = XLSX.utils.json_to_sheet(values[1])
        let issuesRows = XLSX.utils.json_to_sheet(values[2])
        let wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ansiData, 'Summary')
        XLSX.utils.book_append_sheet(wb, subcountryRows, 'Subcountries')
        XLSX.utils.book_append_sheet(wb, issuesRows, 'Issues')
        XLSX.writeFile(wb, `${self.dropdownSelsetValue}_ANSI_Report.xlsx`)
      })
    },
    createShapefileLink() {
      this.url = `https://geoserver-aws.ushrauto.com/geoserver/gm/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=gm:intersections_reports_gm&outputFormat=SHAPE-ZIP&CQL_FILTER=selset='${this.dropdownSelsetValue}'` + '&authkey=' + sessionStorage.token
      window.open(this.url)
    },
    getSelset() {
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION +
              '/api/' +
              this.apiUrl +
              '/getAllIntersectionSelsets',
            {
              method: 'GET',
              headers: {
                'x-auth-token': sessionStorage.token
              }
            }
          )
          .then(response => {
            const content = response.data
            if (!content.errors) {
              this.selset = content.rows
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    renderChart(content) {
      // Sort response data into appropriate axis for graphing
      let chartOptions = []
      let series = []
      let sum = 0
      let caseType = null // Added new variable for displaying sum
      content.forEach(element => {
        if (element.Overall == '') {
          caseType = 'not_reviewed'
        } else {
          caseType = element.Overall
        }
        chartOptions.push(caseType)
        series.push(parseFloat(element.count))
        sum += parseFloat(element.count)
      })
      // Assign sorted data to graph
      ApexCharts.exec('IntersectionReport', 'updateOptions', {
        labels: chartOptions
      })
      ApexCharts.exec('IntersectionReport', 'updateSeries', series)
      this.total = sum
    },
    getANSIReport() {
      this.dropdownSelsetValue = this.ansiSelectedSelset
      this.getReport(this.dropdownSelsetValue)
      this.getAnsiIssues(this)
      this.getAnsiSubcountries(this)
      this.getAnsiData(this)
    },
    getAnsiIssues: async self => {
      if (sessionStorage.token) {
        const rows = await axios
          .get(
            `${process.env.API_LOCATION}/api/${self.apiUrl}/getIntersectionIssues`,
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              },
              params: {
                selset: self.dropdownSelsetValue
              }
            }
          )
          .then(response => {
            self.issuesRows = response.data.rows
          })
          .catch(function (error) {
            console.log(error)
          })
        return self.issuesRows
      }
    },
    getAnsiSubcountries: async self => {
      if (sessionStorage.token) {
        const rows = await axios
          .get(
            `${process.env.API_LOCATION}/api/${self.apiUrl}/getIntersectionSubcountries`,
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              },
              params: {
                selset: self.dropdownSelsetValue
              }
            }
          )
          .then(response => {
            self.subcountryRows = response.data.rows
          })
          .catch(function (error) {
            console.log(error)
          })
        return self.subcountryRows
      }
    },
    getAnsiData: async self => {
      if (sessionStorage.token) {
        const rows = await axios
          .get(
            `${process.env.API_LOCATION}/api/${self.apiUrl}/getIntersectionData`,
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              },
              params: {
                selset: self.dropdownSelsetValue
              }
            }
          )
          .then(response => {
            self.ansiData = response.data.rows
            self.createdDate = response.data.rows[0].created_date
            self.partNumber = response.data.rows[0].part_number
          })
          .catch(function (error) {
            console.log(error)
          })
        return self.ansiData
      }
    },
    refreshModal(selectedSelset) {
      this.getReport(selectedSelset)
      this.createMap(selectedSelset)
    },
    zoomToFitFeatures(layer, selectedSelset) {
      let layerSource = layer.getSource()
      if (selectedSelset) {
        layerSource.updateParams({
          CQL_FILTER: `selset='` + selectedSelset + `'`
        })
      }
      let layerParams = layerSource.getParams()
      let baseUrl = layerSource.getUrl().split('service=')[0]
      let layerType = this.geoserverDetails.filter(
        e => e.name == this.apiUrl
      )[0].layer

      let url =
        baseUrl +
        `service=WFS&request=GetFeature&typeName=gm:intersections_reports_gm&outputFormat=application/json&format_options=callback:getJsonFeatureExtent&authkey=${sessionStorage.token}&CQL_FILTER=selset='${encodeURI(
          this.dropdownSelsetValue
        )}'`
      axios
        .get(url, {})
        .then(response => {
          let features = new GeoJSON().readFeatures(response.data)
          if (features.length != 0) {
            let fittedExtent = new transformExtent(
              new VectorSource({features: features}).getExtent(),
              new projGet('EPSG:4326'),
              new projGet('EPSG:3857')
            )
            let fittedPadding = 20
            let fittedOptions = {
              padding: [
                fittedPadding,
                fittedPadding,
                fittedPadding,
                fittedPadding
              ]
            }
            this.mapANSI.getView().fit(fittedExtent, fittedOptions)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    createMap(selectedSelset) {
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION +
              '/api/' +
              this.apiUrl +
              '/calculateIntersectionExtent',
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              },
              params: {
                selset: this.dropdownSelsetValue
              }
            }
          )
          .then(response => {
            this.layerExtent = response.data.rows[0]
            if (selectedSelset != undefined) {
              this.mapANSI.getLayers().forEach(layer => {
                if (!layer.get('name').includes('OSM')) {
                  this.zoomToFitFeatures(layer, selectedSelset)
                }
              })
            } else {
              this.mapANSI = new Map({
                layers: [
                  new TileLayer({
                    source: new OSM(),
                    name: 'OSM base layer',
                    zIndex: 2
                  })
                ],
                target: 'mapANSI',
                view: new View({
                  center: [this.layerExtent.x, this.layerExtent.y],
                  zoom: 2,
                  minZoom: 2,
                  multiWorld: true,
                  constrainOnlyCenter: true
                })
              })
              let urlInfo = this.geoserverDetails.filter(
                e => e.name == this.apiUrl
              )[0]
              let layerInfo = [
                {
                  display_name: 'Intersections',
                  layerType: 'ImageWMS',
                  name: 'Intersection Report',
                  params: {
                    CQL_FILTER: `selset='` + this.selected + `'`,
                    authkey:sessionStorage.token
                  },
                  url:
                    'https://geoserver-aws.ushrauto.com/geoserver/' +
                    urlInfo.workspace +
                    '/wms?service=WMS&version=1.1.0&request=GetMap&layers=gm:intersections_reports_gm' +
                    '&width=768&height=330&srs=EPSG%3A4326&styles=&format=application/openlayers',
                  zIndex: 500000,
                  zoomControl: false
                }
              ]
              createLayers(layerInfo, this.mapANSI)
              this.mapANSI.getLayers().forEach(layer => {
                if (!layer.get('name').includes('OSM')) {
                  this.zoomToFitFeatures(layer, selectedSelset)
                }
              })
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    }
  },
  watch: {
    layerDefinition: function (newValue, oldValue) {
      this.layerDefinition = newValue
    }
  }
}
</script>
